


























import Vue from 'vue';
import router from '@/router';
import AuthLogin from '@/components/auth/auth-login.vue';
import { getModule } from "vuex-module-decorators";
import UserAuth from "@/store/auth/UserAuth";

export default Vue.extend({

  name: 'BenefitsPage',

  components: {
    'auth-login': AuthLogin,
  },

  props: {},

  data() {
    return {};
  },

  beforeCreate() {
    if (this.$route.path == '/benefits' && !!getModule(UserAuth).user) {
      router.push('/mls');
    }
  },

  watch: {
    isLoggedIn(newVal, oldVal) {
      if (this.$route.path == '/benefits' && newVal) {
        router.push('/mls');
      }
    },
  },

  computed: {
    isLoggedIn(): boolean {
      return !!getModule(UserAuth).user;
    },
  },

  methods: {},

});

